import React, { Component } from 'react';
import { connect } from 'react-redux';
import './updateProfile.scss';
import { Table, Modal, Button } from 'antd';
import NoImage from "../../../images/no-image.jpg";
import EditIcon from "../../../images/edit-icon.png";
import IdentifyVerification from './identifyVerification';
import ResidentileDetail from './residentileDetail';
import FirmDetail from './firmDetail';
import BankDetail from './bankDetail';
import EducationDetail from './educationDetails';
import ExperienceDetail from './experienceDetails';
import TrainingDetail from './trainingDetails';
import ApproveIdentifyVerification from '../../admin/component/approveIdentifyVerification'
import { getUserDetails } from '../action/user.actions'

const trainingColumns = [
	{
		title: 'Certification Name',
		dataIndex: 'certificationName',
	},
	{
		title: 'Certification Type',
		dataIndex: 'certificationType',
	},
	{
		title: 'Grade',
		dataIndex: 'grade',
	},
	{
		title: 'Date',
		dataIndex: 'date',
	},
	{
		title: 'Image',
		dataIndex: 'image',
	},
];

const data = [
	{
		key: '1',
		certificationName: "BCA",
		certificationType: "ABC",
		grade: "A",
		date: "8/10/2020",
		image: "IMAGE"
	},
	{
		key: '2',
		certificationName: "BCA",
		certificationType: "ABC",
		grade: "A",
		date: "8/10/2020",
		image: "IMAGE"
	},
	{
		key: '3',
		certificationName: "BCA",
		certificationType: "ABC",
		grade: "A",
		date: "8/10/2020",
		image: "IMAGE"
	},
	{
		key: '4',
		certificationName: "BCA",
		certificationType: "ABC",
		grade: "A",
		date: "8/10/2020",
		image: "IMAGE"
	},
];



class UpdatePofile extends Component {

	constructor(props) {
		super(props);
		this.state = {
			formError: {},
			formSubmit: false,
			user: {}
		}
	}

	componentDidMount() {
		const { dispatch, user } = this.props;
		dispatch(getUserDetails(user.id))
	}

	handleChange = (e) => {
		const user = Object.assign({}, this.state.user)
		const name = e.target.name;
		const value = e.target.value;
		user[name] = value;
		this.setState({ user });
	}



	showModalExperience = () => {
		this.setState({
			visibleExperience: true,
		});
	};

	handleOkExperience = e => {
		console.log(e);
		this.setState({
			visibleExperience: false,
		});
	};

	handleCancelExperience = e => {
		console.log(e);
		this.setState({
			visibleExperience: false,
		});
	};

	showModalTraining = () => {
		this.setState({
			visibleTraining: true,
		});
	};

	handleOkTraining = e => {
		console.log(e);
		this.setState({
			visibleTraining: false,
		});
	};

	handleCancelTraining = e => {
		console.log(e);
		this.setState({
			visibleTraining: false,
		});
	};
	render() {
		const { user } = this.props;
		let role = user.role && user.role.name || 'Customer'
		const userDetails = this.props.userDetails ? this.props.userDetails : user ;

		return (
			<div style={{display:"grid"}}>
				{
					role == 'Admin' &&
					<ApproveIdentifyVerification userDetails = {userDetails}></ApproveIdentifyVerification>
				}{
					role != 'Admin' && 
					<IdentifyVerification userDetails = {userDetails}></IdentifyVerification>
				}
				<ResidentileDetail userDetails = {userDetails}></ResidentileDetail>
				{
					(role == 'Provider' || role == 'Admin' ) && 
					<div>
						<FirmDetail userDetails = {userDetails}></FirmDetail>
						<BankDetail userDetails = {userDetails}></BankDetail>
					</div>
				}
				{
					role == 'Provider' &&
					<div>
						<EducationDetail></EducationDetail>
						<ExperienceDetail></ExperienceDetail>
						<TrainingDetail></TrainingDetail>
					</div>
				}
			</div>
		)
	}
}

function mapStateToProps(state) {
	const { user } = state.authentication;
	return {
		user,
	}
}
export default connect(mapStateToProps)(UpdatePofile);